import React, { useEffect } from 'react';
import { Formik, Field } from 'formik';
import { connect } from 'react-redux';
import { Col, Row, FormGroup, Label } from 'reactstrap';
import DropDownMenu from '../../../../components/form/DropDownMenu';
import InputField from '../../../../components/form/InputField';
import { Button } from 'react-bootstrap';
import { getArtisanCategoriesAction } from '../../../../modules/artisanCategories/Actions';
import { signupArtisanAction } from '../../../../modules/auth/Actions';

import {
  artisanCategoriesAsLabelAndValueSelector,
  artisanCategoriesIsLoadingSelector,
} from '../../../../modules/artisanCategories/Selectors';

import { authIsLoadingSelector } from '../../../../modules/auth/Selectors';

import { FormattedMessage, injectIntl } from 'react-intl';
import {
  CheckBox,
  FormSectionTitle,
  SearchableSelect,
  Select,
  Upload,
} from '../../../../components/form';

import schema from './schema';

const businessTypeOptions = [
  { value: '0', label: 'Workshop' },
  { value: '1', label: 'Distributor' },
  { value: '2', label: 'Shop' },
];

function ArtisanRegistration(props) {
  // added render={()=>} instead of component in every <Field />

  const {
    intl,
    getArtisanCategories,
    artisanCategories,
    signupArtisan,
    authIsLoading,
  } = props;
  console.log(artisanCategories);
  useEffect(() => {
    getArtisanCategories();
  }, [getArtisanCategories]);
  const artisanCategoriesNew = artisanCategories.map((item, i) => {
    return {
      label: item.name,
      value: item._id,
    };
  });
  console.log(artisanCategoriesNew, 'sign up artisan');
  return (
    <div className="kt-login__body">
      <div className="kt-login__form">
        <div className="kt-login__title">
          <h3>
            <FormattedMessage id="AUTH.REGISTER_ARTISAN.TITLE" />
          </h3>
        </div>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
            city: '',
            country: '',
            province: '',
            zipCode: '',
            userType: ['3'],
            password: '',
            artisanCID: '',
            artisanBIO: '',
            businessName: '',
            businessType: ['0'],
            logo: '',
            onlineStore: false,
            offlineStore: false,
            contactPerson: '',
            contactPersonTitle: '',
            contactPersonPhone: '',
            contactPersonEmail: '',
          }}
          validationSchema={schema(intl)}
          onSubmit={async (values, { setStatus, setSubmitting }) => {
            const result = await signupArtisan(values);
            console.log('submit', 'artisan');
          }}
        >
          {({
            values,
            setFieldValue,
            status,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <>
              <form className="kt-form" onSubmit={handleSubmit}>
                <Row form>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="firstName">
                        {/* First Name */}
                        <FormattedMessage id="AUTH.REGISTER_FIRST.NAME" />
                      </Label>
                      <Field
                        type="text"
                        name="firstName"
                        id="firstName"
                        placeholder="First Name"
                        render={() => <InputField name="firstName" />}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup>
                      <Label for="lastname">
                        {/* last name */}
                        <FormattedMessage id="AUTH.REGISTER_LAST.NAME" />
                      </Label>
                      <Field
                        type="text"
                        name="lastName"
                        id="lastname"
                        placeholder="Last Name"
                        render={() => <InputField name="lastName" />}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <FormGroup>
                  <Label for="email">
                    {/* Email */}
                    <FormattedMessage id="AUTH.REGISTER_EMAIL" />
                  </Label>
                  <Field
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter Your Email"
                    render={() => <InputField name="email" />}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="password">
                    {/* Password */}
                    <FormattedMessage id="AUTH.REGISTER_PASSWORD" />
                  </Label>
                  <Field
                    type="password"
                    name="password"
                    id="password"
                    placeholder="Enter Your Password"
                    render={() => (
                      <InputField name="password" type="password" />
                    )}
                  />
                </FormGroup>
                <hr />
                <FormGroup style={{ display: 'block' }}>
                  <Label for="city">
                    {/* Country */}
                    <FormattedMessage id="AUTH.REGISTER_COUNTRY" />
                  </Label>
                  <Field
                    type="text"
                    name="country"
                    id="country"
                    placeholder="Enter Your Country"
                    render={() => <InputField name="country" />}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="address">
                    {/* Address */}
                    <FormattedMessage id="AUTH.REGISTER_ADDRESS" />
                  </Label>
                  <Field
                    type="text"
                    name="address"
                    id="address"
                    placeholder="Enter Your address"
                    render={() => <InputField name="address" />}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="province">
                    {/* province */}
                    <FormattedMessage id="AUTH.REGISTER_PROVINCE" />
                  </Label>
                  <Field
                    type="text"
                    name="province"
                    id="province"
                    placeholder="Enter Your provincey"
                    render={() => <InputField name="province" />}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="city">
                    {/* City */}
                    <FormattedMessage id="AUTH.REGISTER_CITY" />
                  </Label>
                  <Field
                    type="text"
                    name="city"
                    id="city"
                    placeholder="Enter Your city"
                    render={() => <InputField name="city" />}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="phone">
                    {/* Phone */}
                    <FormattedMessage id="AUTH.REGISTER_PHONE" />
                  </Label>
                  <Field
                    type="number"
                    name="phone"
                    id="phone"
                    placeholder="Enter Your phone"
                    render={() => <InputField name="phone" />}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="zipCode">
                    {/* Zip Code */}
                    <FormattedMessage id="AUTH.REGISTER_ZIPCODE" />
                  </Label>
                  <Field
                    type="number"
                    name="zipCode"
                    id="zipCode"
                    placeholder="Enter Your Zip Code"
                    render={() => <InputField name="zipCode" />}
                  />
                </FormGroup>
                <FormGroup>
                  <Select
                    options={businessTypeOptions}
                    name="businessType"
                    label="BusinessType"
                    inArray={true}
                    // value={values.businessType}
                    // onChange={setFieldValue}
                    // onBlur={setFieldTouched}
                    // error={errors.businessType}
                    // touched={touched.businessType}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="businessName">
                    {/* Business Name */}
                    <FormattedMessage id="AUTH.REGISTER_BUSINESS.NAME" />
                  </Label>
                  <Field
                    type="text"
                    name="businessName"
                    id="businessName"
                    placeholder="Enter Your Business Name"
                    render={() => <InputField name="businessName" />}
                  />
                </FormGroup>
                <Upload
                  data={{ customerID: 'usads9123213k219d123' }}
                  name="logo"
                  label="Logo :"
                  S3Bucket="warshatna-users"
                  // API="customer/customer-category-image-signedurl/"
                  API="users/user-profile-image-signedurl"
                />

                <FormGroup>
                  <Label for="artisanBIO">
                    {/* Bio */}
                    <FormattedMessage id="AUTH.REGISTER_BIO" />
                  </Label>
                  <Field
                    type="text"
                    name="artisanBIO"
                    id="artisanBIO"
                    placeholder="Enter Your Bio"
                    render={() => <InputField name="artisanBIO" />}
                  />
                </FormGroup>

                <FormSectionTitle>
                  {/* Company & Store */}
                  <FormattedMessage id="AUTH.REGISTER_COMPANY.STORE" />
                </FormSectionTitle>
                <CheckBox
                  name="onlineStore"
                  label="Online Store"
                  subLabel="I have Online Store."
                />
                <CheckBox
                  name="offlineStore"
                  label="Offline Store"
                  subLabel="I have Offline Store."
                />

                <FormGroup>
                  <SearchableSelect
                    options={artisanCategories}
                    name="artisanCID"
                    label="Categories"
                    isMulti={true}
                    // value={values.artisanCID}
                    // onChange={setFieldValue}
                    // onBlur={setFieldTouched}
                    // error={errors.artisanCID}
                    // touched={touched.artisanCID}
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="contactPerson">
                    {/* Contact Person */}
                    <FormattedMessage id="AUTH.REGISTER_CONTACT.PERSON" />
                  </Label>
                  <Field
                    type="text"
                    name="contactPerson"
                    id="contactPerson"
                    placeholder="Contact Person"
                    render={() => <InputField name="contactPerson" />}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="contactPersonTitle">
                    {/* Contact Person Title */}
                    <FormattedMessage id="AUTH.REGISTER_CONTACT.PERSON.TITLE" />
                  </Label>
                  <Field
                    type="text"
                    name="contactPersonTitle"
                    id="contactPersonTitle"
                    placeholder="Contact Person Phone"
                    render={() => <InputField name="contactPersonTitle" />}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="contactPersonPhone">
                    {/* Contact Person Phone */}
                    <FormattedMessage id="AUTH.REGISTER_CONTACT.PERSON.PHONE" />
                  </Label>
                  <Field
                    type="text"
                    name="contactPersonPhone"
                    id="contactPersonPhone"
                    placeholder="Contact Person Phone"
                    render={() => <InputField name="contactPersonPhone" />}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="businessName">
                    {/* Contact Person Email */}
                    <FormattedMessage id="AUTH.REGISTER_CONTACT.PERSON.EMAIL" />
                  </Label>
                  <Field
                    type="text"
                    name="contactPersonEmail"
                    id="contactPersonEmail"
                    placeholder="Contact Person Email"
                    render={() => <InputField name="contactPersonEmail" />}
                  />
                </FormGroup>
                <div
                  className="kt-login__actions"
                  style={{ display: 'flex', flexDirection: 'row-reverse' }}
                >
                  <Button disabled={authIsLoading} type="submit">
                    {authIsLoading ? 'loading ...' : 'Sign Up'}
                  </Button>
                </div>
              </form>

              {/* <div
                style={{
                  position: "fixed",
                  width: "300px",
                  height: "400px",
                  left: "20px",
                  top: "20px",
                  backgroundColor: "#fff",
                  color: "#000"
                }}
              >
              </div> */}
            </>
          )}
        </Formik>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  artisanCategories: artisanCategoriesAsLabelAndValueSelector(state),
  isLoading: artisanCategoriesIsLoadingSelector(state),
  authIsLoading: authIsLoadingSelector(state),
});

export default injectIntl(
  connect(mapStateToProps, {
    getArtisanCategories: getArtisanCategoriesAction,
    signupArtisan: signupArtisanAction,
  })(ArtisanRegistration)
);
